<script>
import { get_store_value } from 'svelte/internal';

    //import Flag from "./Flag.svelte";
    import { lang } from './store.js';
//    import CustomVideo  from  "./CustomVideo.svelte";
    import CustomVideo2  from  "./CustomVideo2.svelte";

    export let params = {}

    async function getWristbandInfosFromId(id)  {
        const result = await fetch('https://api.edomedic.com/wristband/lookup/' + id);
        return result.json();
    }

    // let promise = getWristbandInfosFromId(params.id);

    let assets = {
        'Milk' : 'images/Milk-cleaned.svg',
        'Peanuts': 'images/Peanut-cleaned.svg',
        'Sesame': 'images/Sesame-cleaned.svg',
        'Gluten': 'images/Gluten-cleaned.svg',
        'Egg': 'images/Egg-cleaned.svg',
        'Shellfish': 'images/Crustacean-cleaned.svg',
        'Soy': 'images/Soya-cleaned.svg',
        'Nuts': 'images/Walnut-cleaned.svg',
        'Fish': 'images/Fish-cleaned.svg',
        'Corn': 'images/Corn-cleaned.svg',
        'Beans' : 'images/Bean-cleaned.svg',
        'Pistachios' : 'images/Pistachio-cleaned.svg',
        'Cashew nuts' : 'images/CashewNut-cleaned.svg',
        'Lentils': 'images/Lentils-cleaned.svg'
    }

    let now = new Date();
    let currentYear = now.getFullYear();

    let i18n = {}

    function register(key, en, fr, he, ar, ru, es) {
        var mapKey = {};
        mapKey['En'] = en;
        mapKey['Fr'] = fr;
        mapKey['He'] = he;
        mapKey['Ar'] = ar;
        mapKey['Ru'] = ru;
        mapKey['Es'] = es;
        i18n[key] = mapKey;
    }

    register("Hebrew","Hebrew","Hébreu","עברית","اللغة العبرية","иврит","Hebrea");
    register("English","English","Anglais","אנגלית","إنجليزي","английский","Inglesa");
    register("French","French","Français","צרפתית","فرنسي","французский язык","Francesa");
    register("Russian","Russian","Russe","רוסית","الروسية","русский","Rusa");
    register("Arabic","Arabic","Arabe","ערבית","عربى","арабский","Arábica");
    register("Spanish","Spanish","Espagnol","ספרדית","الأسبانية","испанский язык","Española");
    register("German","German","Allemand","גרמנית","ألمانية","Немецкий","Alemana");
    register("Italian","Italian","Italien","איטלקית","إيطالي","Итальянский","Italiana");
    register("Other","Other","Autre","אחר","آخر","Другой","Otra");
    register("years","years","ans","שנים","سنوات","годы","años");
    register("Main allergy","Main allergy","Allergie principale","אלרגיה עיקרית","الحساسية الرئيسية","Основная аллергия","Alergia principal");
    register("Allergy","Allergy","Allergie","אלרגיה","حساسية","Аллергия","Alergia");
    register("Egg","Egg","Œuf","ביצה","بيضة","Яйцо","Huevo");
    register("Milk","Milk","Lait","חלב","لبن","Молоко","Leche");
    register("Fish","Fish","Poisson","דג","سمك","Рыбы","Pez");
    register("Gluten","Gluten","Gluten","גלוטן","الغولتين","Глютен","Gluten");
    register("Peanuts","Peanuts","Cacahuètes","בוטנים","الفول السوداني","Арахис","Miseria");
    register("Shellfish","Shellfish","Crustacés","פירות ים/צדפות","المحار","Моллюски","Mariscos");
    register("Soy","Soy","Soja","סויה","الصويا","Соя","Soja");
    register("Nuts","Nuts","Noix","אגוזים","شجرة الجوز","Лесные орехи","Nueces de árbol");
    register("Sesame","Sesame","Sésame","שומשום","سمسم","Кунжут","Sésamo");
    register("Wheat","Wheat","Blé","חיטה","قمح","Пшеница","Trigo");
    register("Expected symptoms","Expected symptoms","Symptômes attendus","תסמינים צפויים","الأعراض المتوقعة","Ожидаемые симптомы","Síntomas esperados");
    register("Loss of consciousness,","Loss of consciousness,","Perte de connaissance,","אובדן הכרה","ققد الوعي،","Потеря сознания,","Pérdida de consciencia,");
    register("Breathing difficulties","Breathing difficulties","Difficultés respiratoires","קשיי נשימה","صعوبات في التنفس","Затрудненное дыхание","Dificultad para respirar");
    register("Swelling of the face (tongue, lips, etc.),","Swelling of the face (tongue, lips, etc.),","Gonflement du visage (langue, levres etc...),","נפיחות בפנים (לשון, שפתיים וכו '),","تورم في الوجه (اللسان ، الشفتين ، إلخ) ،","Отек лица (языка, губ и т. Д.),","Hinchazón de la cara (lengua, labios, etc.).");
    register("Redness / Itching,","Redness / Itching,","Rougeures / Démengeaisons,","אדמומיות / גירוד,","احمرار / حكة،","Покраснение / зуд,","Enrojecimiento / picazón");
    register("Rapid aggravation.","Rapid deterioration.","Aggravation rapide.","הידרדרות מהירה.","تفاقم سريع.","Быстрое обострение.","Agravamiento rápido.");
    register("Urgent actions to take","Urgent actions to take","Actions urgentes à effectuer","יש לבצע פעולות דחופות","اتخاذ إجراءات عاجلة","Срочные действия, которые необходимо предпринять","Acciones urgentes a tomar");
    register("Check that there is no","Check that there is no","Vérifier qu’il n’y ait pas de","יש לבדוק שאין","تأكد من عدم وجود ملفات","Убедитесь, что нет","Compruebe que no haya");
    register("in his mouth or within reach.","in his mouth or within reach.","dans sa bouche ou à portée de main.","בפיו או במגע","في فمه أو في متناول اليد.","во рту или в пределах легкой досягаемости.","en su boca o al alcance de la mano.");
    register("Recommendations","Recommendations","Recommandations","המלצות","التوصيات","Рекомендации","Recomendaciones");
    register("Reassure the child","Reassure the child","Rassurer l'enfant","להרגיע את הילד","طمأن الطفل","Успокойте ребенка","Tranquiliza al niño");
    register("Make the child breathe through the nose","Make the child breathe through the nose","Que l'enfant respire par le nez","על הילד לנשום מהאף","اجعل الطفل يتنفس من خلال أنفه","Заставьте ребенка дышать носом","Hacer que el niño respire por la nariz.");
    register("Contact emergencies.","Contact emergencies.","Contacter les urgences.","לפנות לחירום.","الاتصال في حالات الطوارئ","Свяжитесь с нами в экстренных случаях.","Comuníquese con emergencias.");
    register("Contacts","Contacts","Contacts","אנשי קשר","جهات الاتصال","Контакты","Contactos");
    register("We recommend that you send a photo to the contacts.","We recommend that you send a photo to the contacts.","Nous vous conseillons d’envoyer une photo aux contacts.","אנו ממליצים לשלוח תמונה לאנשי הקשר.","نوصي بإرسال صورة إلى جهات الاتصال.","Рекомендуем отправить фото в контакты.","Le recomendamos que envíe una foto a los contactos.");
    register("Important message","Important message","Message important","הודעה חשובה","رسالة مهمة","Важное сообщение","Mensaje importante");
    register("How to use the EpiPen","How to use the EpiPen","Comment utiliser l’EpiPen","כיצד להשתמש ב- EpiPen","كيفية استخدام قلم الإبينفرين","Как использовать EpiPen","Cómo usar el EpiPen");
    register("Movements for performing cardiac massage on a child","Cardiac massages actions on a child","Mouvements pour effectuer un massage cardiaque sur un enfant","פעולות לביצוע עיסוי לב","حركات تدليك القلب للطفل","Движения для выполнения массажа сердца ребенку","Movimientos para realizar masaje cardíaco en un niño.");
    register("Other information","Other information","Autres informations","מידע נוסף","معلومات أخرى","Дополнительная информация","Otra información");
    register("Please wait a moment...","Please wait...","Merci de patienter un instant...","אנא המתן…","من فضلك انتظر لحظة ...","Пожалуйста, подождите ...","Por favor, espere un momento ...");
    register("Corn","Corn","Maïs","תירס","حبوب ذرة","Кукуруза","Maíz");
    register("Cashew nuts","Cashew nuts","Noix de Cajou","אגוזי קשיו","الكاجو","Орехи кешью","Nueces de anacardo");
    register("Pistachios","Pistachios","Pistaches","פיסטוקים","فستق","Фисташки","Pistachos");
    register("Beans","Beans","Haricots","שעועית","فاصوليا","Бобы","Frijoles");
    register("Lentils","Lentils","Lentilles","עדשים","عدس","Чечевица","Lentejas");
    register("Allergies","Allergies","Allergies","אלרגיות","الحساسية","Аллергии","Alergias");
    register("The wristband has not been configured properly. If you are the owner, please install the Edomedic Admin Application and scan the QR Code from your owner card to configure the wristband.","The wristband has not been configured properly. If you are the owner, please install the Edomedic Admin Application and scan the QR Code from your owner card to configure the wristband.","Le bracelet n'a pas été configuré correctement. Si vous êtes le propriétaire du bracelet, veuillez installer l'application d'administration Edomedic et scanner le QR code de votre carte de propriétaire pour le configurer.","הצמיד לא הוגדר כראוי. התקן את אפליקציית הניהול של Edomedic וסרוק את קוד QR מכרטיס הבעל כדי להגדיר אות הצמיד.","لم يتم تكوين سوار المعصم بشكل صحيح. يرجى تثبيت تطبيق Edomedic Admin ومسح رمز الاستجابة السريعة من بطاقة المالك الخاصة بك لإعادة تكوين سوار المعصم.","Браслет настроен неправильно. Установите приложение Edomedic Admin и отсканируйте QR-код с карты владельца, чтобы перенастроить браслет.","La pulsera no se ha configurado correctamente. Instale la aplicación de administración de Edomedic y escanee el código QR de su tarjeta de propietario para configurar la pulsera.");

    register("Generic page","Generic page","Page générique ","עמוד כללי","صفحة عامة","Общая страница","Página Genérica");
    register("Infos titre","In order to obtain personalized information:","Afin d'obtenir les informations personnalisées:","על מנת לקבל מידע מותאם אישית:","من أجل الحصول على معلومات شخصية:","Для получения персонализированной информации:","Para obtener información personalizada:");
    register("configNFC1","bring your phone closer to the child's wristband","rapprocher votre téléphone du bracelet de l’enfant","קרבו את הטלפון אל צמיד של הילד","اجعل هاتفك أقرب إلى سوار معصم الطفل","поднесите телефон ближе к браслету ребенка","acerque su teléfono a la pulsera del niño y");
    register("configNFC2","click on the NFC activation button","cliquer sur le bouton d’activation du NFC ","לחץ על כפתור ההפעלה של NFC","انقر فوق زر تنشيط NFC","нажмите на кнопку активации NFC","haga clic en el botón de activación de NFC");
    register("EpipenInfos","In severe cases, it is necessary to use the Epipen to save the child","Dans les cas graves, il est nécessaire d'utiliser l'Epipen pour sauver l'enfant","במקרים חמורים יש צורך להשתמש באפיפן כדי להציל את הילד","في الحالات الشديدة من الضروري استخدام Epipen لإنقاذ الطفل","В тяжелых случаях необходимо использовать Эпипен для спасения ребенка.","En casos severos es necesario usar el Epipen para salvar al niño");
    register("Allergic1","Check that there is no allergic product","Vérifier qu’il n’y ait pas de produit allergique","בדקו שאין מוצר אלרגי","تأكد من عدم وجود منتج للحساسية","Убедитесь, что нет аллергического продукта","Comprobar que no hay ningún producto alérgico");
    register("Allergic2","in his mouth or near the child.","dans sa bouche ou à proximité de l'enfant.","בפיו או ליד הילד.","في فمه أو بالقرب من الطفل.","во рту или рядом с ребенком.","en su boca o cerca del niño.");
    
    function translate(ln) {
        return function (prefix)  {
            if (i18n[prefix] == undefined) return prefix;
            return i18n[prefix][ln];
        };
    }

    function direction(l) {
        if ((l == 'He') || (l == 'Ar') ) {
            return 'rtl';
        }
        else {
            return 'ltr';
        }
    }

    function nfcExists() {
        return window.NDEFReader != undefined;
    }

    function nfcActivation() {
        const ndef = new NDEFReader();
        ndef.scan().then(() => {
        console.log("Scan started successfully.");
        ndef.onreadingerror = () => {
            console.log("Cannot read data from the NFC tag. Try another one?");
            const decoder = new TextDecoder();
            for (const record of event.message.records) {
                consoleLog("Record type:  " + record.recordType);
                consoleLog("MIME type:    " + record.mediaType);
                consoleLog("=== data ===\n" + decoder.decode(record.data));
            }
        };
        ndef.onreading = event => {
            console.log("NDEF message read.");
        };
        }).catch(error => {
        console.log(`Error! Scan failed to start: ${error}.`);
        });
    }
</script>

<center>

<section>
	<p class="infos" dir="{direction($lang)}">{translate($lang)('Generic page')}</p>
</section>    


<section>
        <div class="infos  align{direction($lang)}" dir="{direction($lang)}">{translate($lang)('Infos titre')}
        <ul class="infos2 align{direction($lang)}" dir="{direction($lang)}">
            <li dir="{direction($lang)}">{translate($lang)('configNFC1')}</li>
            <li dir="{direction($lang)}">{translate($lang)('configNFC2')}</li>
        </ul>
        <table class='nfcTable' dir="{direction($lang)}">
            <tr><td class='tdNfcLogo'><img class='nfcLogo' src='./images/nfc.png' alt="NFC button for Android"></td><td class='tdNfcLogo'><img class='nfcLogo' src='./images/nfc-apple.jpg' alt="NFC button for IOS"></td></tr>
        </table>
    </div>
<!--
        <button on:click|once={nfcActivation}>NFC Activation</button>
-->        
</section>

<section>
</section>

<br/>
<section>
    <table width='100%' border="0px" dir="{direction($lang)}">
         <tr>
            <td class="tdImage td1Image"><img class="imageIcon"  id="difficultResp" src='./images/difficultResp.png' alt="{translate($lang)('Expected symptoms')}" /></td>
            <td class="tdExplanations">
                <div class="tdTitle align{direction($lang)}">{translate($lang)('Expected symptoms')}</div><br/>
                <div class="tdText align{direction($lang)}">{translate($lang)('Loss of consciousness,')}<br/>{translate($lang)('Breathing difficulties')}<br/>{translate($lang)('Swelling of the face (tongue, lips, etc.),')}<br/>{translate($lang)('Redness / Itching,')}<br/>{translate($lang)('Rapid aggravation.')}</div>
            </td>
        </tr>
        
        <tr>
            <td class="tdImage td2Image"><img class="imageIcon"  id="exclamationMark"  src='./images/exclamationMark.png' alt="{translate($lang)('Urgent actions to take')}" /></td>
           <td class="tdExplanations">
                <div class="tdTitle align{direction($lang)}">{translate($lang)('Urgent actions to take')}</div><br/>
               
                <div class="tdText align{direction($lang)}">{translate($lang)('Allergic1')} {translate($lang)('Allergic2')}<br/></div>
                      
    </td>
    </tr>
        <tr>
            <td class="tdImage td3Image"><img class="imageIcon"  id="bubble"  src='./images/bubble.png' alt="{translate($lang)('Important message')}" /></td>
            <td class="tdExplanations">
                <div class="tdTitle align{direction($lang)}">EPIPEN</div><br/>
                
                <div class="tdText align{direction($lang)}">{translate($lang)('EpipenInfos')}<br/></div>

                <p id='epipen'>{translate($lang)('How to use the EpiPen')}</p>
                <CustomVideo2 poster='videos/Epipen.jpg' src='videos/Epipen.mp4'/><br/>
                
            </td>
        </tr>
         <tr>
            <td class="tdImage td4Image"><img class="imageIcon" id="sos"  src='./images/sos.png' alt="{translate($lang)('Recommendations')}" /></td>
            <td class="tdExplanations">
                <div class="tdTitle align{direction($lang)}">{translate($lang)('Recommendations')}</div><br/>
                <div class="tdText align{direction($lang)}">{translate($lang)('Reassure the child')}<br/>{translate($lang)('Make the child breathe through the nose')}<br/>{translate($lang)('Contact emergencies.')}</div>
            </td>
        </tr>
    </table>
</section>
<br/>
<br/>

</center>


<style>
    div {
        text-align: center;
    }
    p {
		color: white;
		/* text-transform: uppercase; */
        text-align: center;
		font-size: 1em;
		font-weight: 100;
    }
    section {
        width: 100%;
        max-width: 460px;
        /* border: 4px solid green; */
    }
    .infos {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 22px;
        color: #FFFFFF;       
    }

    .infos2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 17px;
        color: #FFFFFF;
    }

    .nfcTable {
        margin-left: auto;
        margin-right: auto;
        width: '200px';
        border: "0px";
    }

    .tdNfcLogo {
        width: 80px;
    }

    .nfcLogo {
        width: 60px;
        height: 60px;
    }

    .tdImage {
        background: #FFFFFF;
        box-sizing: border-box;
        width: 80px;
        height: auto;
        text-align: center;
    }

    .td1Image {
        border: 4px solid #B30024;
    }

    .td2Image {
        border: 4px solid #E3191C;
    }

    .td3Image {
        border: 4px solid #FC4E29;
    }

    .td4Image {
        border: 4px solid #FD8D3C;
    }

    .tdExplanations {
        padding: 10px;
        width: 100%;
    }

    .tdTitle  {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 27px;
        line-height: 32px;
        color: #FFFFFF;
        width: 100%;
        word-break: break-word;
     }

    .alignltr {
        text-align: left;
    } 
    .alignrtl {
        text-align: right;
    } 

    .tdText {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #FFFFFF;

        width: 100%;
        word-break: break-word;
    }

    .tdContact {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 22px;
        line-height: 26px;
        color: #FFFFFF;
        width: 100%;
    }

    .phone {
        width: 25px;
        height: 25px;
        padding: 10px;
    }
    .whatsapp {
        width: 25px;
        height: 25px;
        padding: 10px;
    }
    .telegram {
        width: 25px;
        height: 25px;
        padding: 10px;
    }
    .more {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 23px;
        color: #FFFFFF;
    }

    .allergy {
        height: 60px;
        filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(343deg) brightness(104%) contrast(101%);
     }

    #Peanuts {
        /* 1118 × 1665 */
        /* width: 40.28px;  */
        height: 60px;
        color: white;
    }

    #Milk {
        /* 1152 × 2272 */
        /* width: 30.42px; */
        height: 60px;
    }

    #Sesame {
        /* 2068 × 2203 */
        /* width: 56.32px; */
        height: 60px;
    }

    #Gluten {
        /* 1520 × 2641 */
        /* width: 34.54px; */
        height: 60px;
    }

    #Egg {
        /* 1659 × 2231 */
        /* width: 44.62px; */
        height: 60px;
    }

    #Shellfish {
        /* × */
        /* width: 60px;  */
        height: 60px;
    }

    #Soy {
        /* × */
        /* width: 60px; */
        height: 60px;
    }

    #Nuts {
        /* × */
        /* width: 60px; */
        height: 60px;
    }

    #Fish {
        /* × */
        /* width: 60px; */
        height: 60px;
    }

    #Corn {
        /* × */
        /* width: 60px; */
        height: 60px;
    }

    /* #difficultResp {
         /* 1021 × 987 */
         /* width: 70px;
         height: 67px; 
     }

    #exclamationMark {
         /* 236 × 724 */
         /* width: 70px;
         height: 215px; 
    }

    #bubble {
         /* 642 × 638 */
         /* width: 70px;
         height: 70px; 
    }

    #sos {
         /* 681 × 681 */  
         /* width: 70px;
         height: 70px;
    } */

    #contacts {
        padding: 10px;
        height: 60px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 29.9863px;
        line-height: 35px;
        color: #FFFFFF;
        vertical-align: middle;
        background: linear-gradient(180deg, rgba(230, 230, 230, 0.76) 0%, rgba(255, 255, 255, 0) 100%);
    }
 
    @media (min-width: 350px) {
        .imageIcon {
            width: 70px;
        }
        .tdImage {
            width: 80px;
        }
    }

    @media (max-width: 350px) {
        .imageIcon {
            width: 60px;
        }
	    .tdImage {
			width: 70px;
		}
    }
 </style>